import { ThunkType } from "../../../../../core/store/reducers";
import { getDailySecurityReport } from "../api/getDailySecurityReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../dailySecurityDataSlice";

export const downloadSecurityReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const { filter } = store.ux.reports.securityCommission.dailySecurity;
	const user = store.data.auth.current.user;
	dispatch(setFetchState({ type: "started" }));
	const ordersReport = await dispatch(getDailySecurityReport(user, filter));
	if (ordersReport) {
		fileDownload(new Blob([ordersReport as any], { type: "application/pdf" }), "DailySecurityTrading.pdf");
	}
	dispatch(setFetchState({ type: "not-started" }));

};
